import React from "react";
import {Col, Form} from "react-bootstrap";

function FormRowCol(props) {
  return (
    <Form.Row>
      <Col {...props}>
        {props.children}
      </Col>
    </Form.Row>
  )
}

export default FormRowCol
